{
  "optimizationInputsForm": {
    "sections": {
      "initialDimensions": "Anfangsmaße",
      "variations": "Varianten",
      "sizesToTest": "Zu testende Größen",
      "aircraftMix": "Flugzeugmix"
    },
    "labels": {
      "width": "Breite ({{unit}})",
      "depth": "Tiefe ({{unit}})",
      "widthVariation": "+/- Breite ({{unit}})",
      "depthVariation": "+/- Tiefe ({{unit}})",
      "searchAircraft": "Suche nach Hersteller und Modell",
      "numberAircraft": "# Flugzeuge",
      "configurations": "Konfigurationen"
    },
    "tableHeaders": {
      "make": "Neu",
      "model": "Modell",
      "wingspan": "Spannweite ({{unit}})",
      "length": "Länge ({{unit}})",
      "tailHeight": "Heckhöhe ({{unit}})"
    }
  },
  "optimizationHangarResults": {
    "buttons": {
      "stop": "Stopp",
      "run": "Los"
    },
    "tableHeaders": {
      "hangar": "Hangar",
      "doors": "Türen",
      "progress": "Fortschritt",
      "numberInHangar": "Anz. im Hangar",
      "utilization": "Auslastung",
      "worst": "Schlecht",
      "best": "Beste",
      "average": "Ø-Wert"
    }
  }
}
